<div class="emptypage-title ">
  <h2 [langkey]="emptyTitle"></h2>
</div>
<div class="emptypage-message">
  <p [langkey]="emptyContent"></p>
</div>